export default "__VITE_ASSET__Co5ly8kZ__"